import { getCssValue } from './get-css-value'
import CodeManager from 'Functions/code-manager'

window.stlst_legacy.getDefaultValue = function( id, control, defaultOnly = false ) {
	return getDefaultValue( id, control, defaultOnly );
}

/**
 *
 * @param {string} id Css property name. Like: text-align.
 * @param {string} control Styling control type. Like: color, slider, etc.
 * @param {bool} defaultOnly Return default CSS only without our generated css.
 *
 * @returns {String} Css value for provided id.
 */
export default function getDefaultValue( id, control = false, defaultOnly = false ) {
	// Get current selector.
	// ex: .site-branding-text h1
	const selector = window.Stylist.cssSelectorCustom
	// Get slected jQuery element.
	const jqElement = window.Stylist.iDocJQ.find( selector );
	// Get styleAttr.
	let inlineStyleData = jqElement.attr( "style" );
	// Current media size.
	const size = window.stlst_legacy.get_media_condition();
	const cssCode = CodeManager.getCode()
	// Replace fake rules as scale-transfrom.
	const ruleID = id;
	// Get details
	const elementID = ruleID; // ex.: font-weight
	// data is default value
	let data, numberData;

	// ============================================================
	// Remove style attr before getting value for position id.
	if ( 'position' === id ) {
		if ( window.stlst_legacy.isUndefined( inlineStyleData ) ) {
			inlineStyleData = '';
		} else {
			jqElement.removeAttr( "style" );
		}
	}

	// ============================================================
	// Getting CSS Data.
	if ( 	id != 'transform' &&
			id != 'border-width' &&
			id != 'border-color' &&
			id != 'border-style' ) {
		data = jqElement.css( id );
		numberData = window.stlst_legacy.number_filter( data );
	}

	// If data exists at CSS editor, get it.
	// defaultOnly - means we want only our custom/generated styles.
	if ( ! defaultOnly ) {
		const defaultData = getCssValue( {
			cssSelector: selector,
			cssProperty: id,
			responsiveSize: size } )

		if ( false !== defaultData ) {
			numberData = window.stlst_legacy.number_filter( defaultData )
			data = defaultData
		}
	}

	// Don't proceed if we are working with a shorthand declaration
	// (with multiply values).
	// DISABLED as not possible any more with postCSS preprocessing.
	if ( 'margin' === id || 'padding' === id || 'border-radius' === id ) {
		// @todo: improve to extract some meaningful value.
		// like: 33px 44px 55px 0px should return 33px
		if ( undefined !== data && data.includes( ' ' ) ) {
			data = '0px';
			numberData = 0;
		}
	}

	// ============================================================
	// Don't set auto for top and left
	if ( 'auto' === data && ( 'top' === id || 'left' === id ) ) {
		data = '0px';
		numberData = 0;
	}

	// Border: default is ALL
	/* if ( 'border-type' === id ) {
		// Update only if not have a active radio.
		// @todo: review this code!
		if ( jQuery( "#border-type-group" ).find( ".stlst-radio.active" ).length == false ) {
			data = 'all';
		}
	} */

	// Getting format: px, em, etc.
	let format = window.stlst_legacy.alfa_filter( data ).replace( /(\.|\,)/g, '' );

	// Chome return "rgba(0,0,0,0 )" if no background color,
	// its is chrome hack.
	if ( id === 'background-color' && data === 'rgba(0, 0, 0, 0 )' ) {
		data = 'transparent';
	}

	// checks
	if ( id == 'position' && data == 'relative' && inlineStyleData.indexOf( "relative" ) != -1 ) {
		data = 'static';
	}

	// add deleted style attr again
	if ( id == 'position' ) {
		if ( ! window.stlst_legacy.isUndefined( inlineStyleData ) ) {
			jqElement.attr( inlineStyleData );
		}
	}

	/*
	// Check border style
	let top;
	if ( id == 'border-style' ) {

		data = 'solid';
		top = jqElement.css( "borderTopStyle" );

		if ( top == jqElement.css( "borderLeftStyle" ) && top == jqElement.css( "borderRightStyle" ) && top == jqElement.css( "borderBottomStyle" ) ) {
			data = top;
		}
	}

	// Check border width
	if ( id == 'border-width' ) {

		data = '0px';
		numberData = 0;

		top = jqElement.css( "borderTopWidth" );

		if ( top == jqElement.css( "borderLeftWidth" ) && top == jqElement.css( "borderRightWidth" ) && top == jqElement.css( "borderBottomWidth" ) ) {
			data = top;
			numberData = window.stlst_legacy.number_filter( top );
		}
	}

	// Check border color
	if ( id == 'border-color' ) {

		data = jqElement.css( "color" );

		top = jqElement.css( "borderTopColor" );

		if ( top == jqElement.css( "borderLeftColor" ) && top == jqElement.css( "borderRightColor" ) && top == jqElement.css( "borderBottomColor" ) ) {
			data = top;
		}
	}
	*/

	// Check if margin left/right is auto or else.
	// DISABLED AS NOT PERFECT
	// @todo: we have issue with false-positive auto for margin-left/right when wrapped with parent.
	/*
	if ( id == 'margin-left' || id == 'margin-right' ) {

		let frameWidth = iframe.width();

		let marginLeft = parseFloat( jqElement.css( "marginLeft" ) );
		let width = parseFloat( jqElement.css( "width" ) );

		// Full in frame with margins
		if ( frameWidth == ( marginLeft * 2 ) + width && marginLeft > 0 ) {

			data = 'auto';
			numberData = 0;

			// Full in parent with margins
		} else if ( jqElement.parent().length > 0 ) {
			if ( parseFloat( jqElement.parent().width() ) == ( ( marginLeft * 2 ) + width ) && marginLeft > 0 ) {
				data = 'auto';
				numberData = 0;
			}
		}
	}
	*/

	// filter = explode filter data to parts
	if ( elementID == 'filter' ) {
		// Try to get css with webkit prefix.
		if ( data === null || data == 'none' || data === undefined ) {
			data = jqElement.css( "-webkit-filter" ); // for chrome.
		}

		// Special default values for filter css rule.
		if ( data != 'none' && data !== null && data !== undefined ) {
			/*
			// Get brightness, blur etc from filter data.
			data = data.match( new RegExp(cssDetail + "\\((.*?)\\)", "g" ) );

			// is?
			if ( window.stlst_legacy.isDefined( data ) ) {

				// replace prefixes
				data = data.toString().replace( "deg", "" ).replace( "hue-rotate( ", "" ).replace( " )", "" );

				// Update data
				data = window.stlst_legacy.number_filter( data );

				// Update number data
				numberData = data;

			} else {
			*/

			// Set default
			data = 'disable';
			numberData = 0;

			// }
		} else {
			// Set default
			data = 'disable';
			numberData = 0;
		}
	}

	// Font weight fix.
	if ( 'font-weight' === id ) {
		if ( 'bolder' === data ) {
			data = '700'
		}
		if ( 'bold' === data ) {
			data = '600'
		}
		if ( 'normal' === data ) {
			data = '400'
		}
		if ( 'lighter' === data ) {
			data = '300'
		}
	}

	// transform = explode transform data to parts
	if ( 'transform' === elementID ) {
		// Get transfrom style from editor data.
		data = getCssValue( {
			cssSelector: selector,
			cssProperty: id,
			responsiveSize: size
		} )

		// Getting transform value from HTML Source ANIM.
		const styleString = null

		// explode transform data
		if ( data != 'none' && data !== false && data !== undefined ) {
			/*
			// Get brightness, blur etc from filter data.
			data = data.match( new RegExp(cssDetail + "\\((.*?)\\)", "g" ) );

			// is?
			if ( window.stlst_legacy.isDefined( data ) ) {

				// String.
				data = data.toString();

				// Update data
				data = window.stlst_legacy.number_filter( data );

				// Update number data
				numberData = data;

			} else {
				*/

			// Set default
			data = 'disable';
			numberData = 0;

			// }
		} else {
			// Set default
			data = 'disable';
			numberData = 0;
		}
	}

	// Set auto
	if ( 'min-width' === id || 'min-height' === id ) {
		if ( parseFloat( data ) == 0 ) {
			data = 'auto';
		}
	}

	// Check bottom and set auto
	if ( 'bottom' === id ) {
		if ( parseFloat( jqElement.css( "top" ) ) + parseFloat( jqElement.css( "bottom" ) ) === 0 ) {
			data = 'auto';
		}
	}

	// Check right and set auto
	if ( 'right' === id ) {
		if ( parseFloat( jqElement.css( "left" ) ) + parseFloat( jqElement.css( "right" ) ) === 0 ) {
			data = 'auto';
		}
	}

	// Box Shadow.
	if ( 'box-shadow' === elementID && data != 'none' && data !== null && data !== undefined ) {
		// Box shadow color default value.
		if ( id == 'box-shadow-color' ) {
			// Hex
			if ( data.indexOf( "#" ) != -1 ) {
				if ( data.split( "#" )[ 1 ].indexOf( "inset" ) == -1 ) {
					data = jQuery.trim( data.split( "#" )[ 1 ] )
				} else {
					data = jQuery.trim( data.split( "#" )[ 1 ].split( ' ' )[ 0 ] )
				}
			} else if ( data.indexOf( "rgb" ) != -1 ) {
				data = data.match( /rgb(.*?)\((.*?)\)/g ).toString()
			}
		}

		// split all box-shadow data.
		const numbericBox = data.replace( /rgb(.*?)\((.*?)\) /g, '' ).replace( / rgb(.*?)\((.*?)\)/g, '' ).replace( /inset /g, '' ).replace( / inset/g, '' )

		// shadow horizontal value.

		if ( id == 'box-shadow-horizontal' ) {
			data = numbericBox.split( " " )[ 0 ]
			numberData = window.stlst_legacy.number_filter( data )
		}

		// shadow vertical value.
		if ( id == 'box-shadow-vertical' ) {
			data = numbericBox.split( " " )[ 1 ];
			numberData = window.stlst_legacy.number_filter( data )
		}

		// Shadow blur radius value.
		if ( id == 'box-shadow-blur-radius' ) {
			data = numbericBox.split( " " )[ 2 ];
			numberData = window.stlst_legacy.number_filter( data )
		}

		// Shadow spread value.
		if ( id == 'box-shadow-spread' ) {
			data = numbericBox.split( " " )[ 3 ];
			numberData = window.stlst_legacy.number_filter( data )
		}
	}

	// if no info about inset, default is no.
	if ( 'box-shadow-inset' === id ) {
		if ( window.stlst_legacy.isUndefined( data ) ) {
			data = 'no';
		} else if ( -1 === data.indexOf( "inset" ) ) {
			data = 'no'
		} else {
			data = 'inset'
		}
	}

	// if special CSS, get css by CSS data.
	// ie for parallax. parallax not a css rule.
	// yellow pencil using css engine for parallax Property.
	if ( jqElement.css( id ) === undefined && window.Stylist.iBodyJQ.find( '.' + elementID + '__' + id + '__style' ).length > 0 ) {
		data = getCssValue( {
			cssSelector: selector,
			cssProperty: id,
			responsiveSize: size
		} );
		numberData = window.stlst_legacy.number_filter( data );
	}

	// IF THIS IS A SLIDER
	// ============================================================
	if ( 'slider' === control ) {
		// Line heigt with relative units.
		if ( id === 'line-height' && '' === format ) {
			// return numberData
			return data
		}

		// If not inline
		if ( jqElement.css( "display" ) != 'inline' || jqElement.css( "display" ).indexOf( "table" ) != -1 ) {
			// if has children and id is height
			if ( id == 'height' && jqElement.children().length > 0 && jqElement.children().length < 12 ) {
				const elHeight = jqElement.css( "height" );
				let tHeight;

				// parent is display block
				jqElement.children().each( function() {
					tHeight = jQuery( this ).css( "height" );

					if ( elHeight == tHeight ) {
						data = 'auto'
						return data
					}
				} )
			}
		}

		// if no data, active none option.
		if ( data == 'none' || data == 'auto' || data == 'inherit' || data == 'initial' ) {
			return data;
		}

		format = jQuery.trim( format );

		// be sure format is valid.
		if ( format === '' || format == 'px .px' || format == 'px px' ) {
			format = 'px';
		}

		// be sure format is valid.
		if ( format.indexOf( "px" ) != -1 ) {
			format = 'px';
		}

		/*

		// Default value is 1 for transform scale.
		if ( numberData == '' && id == 'scale-transform' ) {
			numberData = 1;
		}

		// Default value is 1 for filter
		if ( numberData == '' && id == 'brightness-filter' ) {
			numberData = 1;
		}

		// Default value is 1 for filter
		if ( numberData == '' && id == 'contrast-filter' ) {
			numberData = 1;
		}

		// Default value is 1 for filter
		if ( numberData == '' && id == 'saturate-filter' ) {
			numberData = 1;
		}

		// default value is 1 for opacity.
		if ( numberData == '' && id == 'opacity' ) {
			numberData = 1;
		}

		*/

		// If no data, set zero value.
		if ( numberData == '' ) {
			numberData = 0;
		}

		/*
		@todo: move range limitators into the slider component

		let range = idPrt.data( "px-range" ).split( "," );

		let jQuerymin = parseInt(range[0]); // mininum value
		let jQuerymax = parseInt(range[1]); // maximum value

		// Check values.
		if ( numberData < jQuerymin) {
			jQuerymin = numberData;
		}

		if ( numberData > jQuerymax) {
			jQuerymax = numberData;
		}

		// Speacial max and min limits for CSS size rules.
		if ( id == 'width' || id == 'max-width' || id == 'min-width' || id == 'height' || id == 'min-height' || id == 'max-height' ) {
			jQuerymax = parseInt( jQuerymax) + ( parseInt( jQuerymax) * 1.5 );
			jQuerymin = parseInt( jQuerymin) + ( parseInt( jQuerymin) * 1.5 );
		}
		*/

		// if width/height is same with windows width, set 100%!
		// Note: browsers always return value in PX format.
		if ( jqElement.css( "display" ) != 'inline' ) {
			// Width
			if ( id == 'width' && jqElement.parent().length > 0 ) {
				// is px and display block
				if ( format == 'px' && jqElement.parent().css( "display" ) != 'inline' && jqElement.parent().css( "display" ) != 'inline-flex' && jqElement.parent().css( "display" ).indexOf( "table" ) == -1 ) {
					const parentWidth = jqElement.parent().width();

					// if width is same with parent width, so set 100%!
					if ( parentWidth == parseInt( numberData ) ) {
						numberData = '100';
						format = '%';
					}

					// if width is 50% of parent width, so set 50%!
					if ( parseInt( parentWidth / 2 ) == ( parseInt( numberData ) ) ) {
						numberData = '50';
						format = '%';
					}

					// if width is 25% of parent width, so set 25%!
					if ( parseInt( parentWidth / 4 ) == ( parseInt( numberData ) ) ) {
						numberData = '25';
						format = '%';
					}

					// if width is 20% of parent width, so set 20%!
					if ( parseInt( parentWidth / 5 ) == ( parseInt( numberData ) ) ) {
						numberData = '20';
						format = '%';
					}
				}
			}

			// if  height is 100% of window height!
			if ( id == 'height' && parseInt( jQuery( window ).height() ) == parseInt( numberData ) && format == 'px' ) {
				numberData = '100';
				format = 'vh';
			}
		}

		// max and min for %.
		/*
		if ( format == '%' ) {
			range = jQuery('#' + id + '-group' ).attr( "data-pcv" ).split( "," );
			jQuerymin = range[0];
			jQuerymax = range[1];
		} else if ( format == 'em' ) {
			range = jQuery('#' + id + '-group' ).attr( "data-emv" ).split( "," );
			jQuerymin = range[0];
			jQuerymax = range[1];
		}
		*/

		// Round
		numberData = Math.floor( numberData * 100 ) / 100;

		// Integer only.
		if ( 'height' === id || 'font-size' === id || id.indexOf( "margin-" )
				|| id.indexOf( "padding-" ) || id.indexOf( "border-width" )
				|| id.indexOf( "-radius" ) || id.indexOf( "z-index" )
				|| id == 'top' || id == 'right' || id == 'bottom' || id == 'left' ) {
			numberData = parseInt( numberData );
		}

		format = format.replace( /\./g, '' );

		if ( isNaN( numberData ) || undefined === numberData || false === numberData ) {
			return 0
		}

		// Font-weight property doesn't need units ( px).
		if ( 'font-weight' === id ) {
			return numberData
		} //Else

		return numberData + format

	// IF THIS IS FONT CONTROL
	// ============================================================
	} else if ( 'font-family' === id ) {
		if ( window.stlst_legacy.isDefined( data ) ) {
			return data;

			// data = jQuery.trim( data.replace( /"/g, "" ).replace( /'/g, "" ) );

			// Append default font family to body. only for select font family.
			/* if ( jQuery( ".stlst-font-test-" + window.stlst_legacy.get_basic_id( jQuery.trim( data.replace( / /g, '+' ) ) ) ).length === 0 && id == 'font-family' ) {

				// If safe font, stop.
				if ( window.stlst_legacy.is_safe_font( data ) === false) {

					// Be sure its google font.
					if ( is_google_font( data ) ) {

						// Append always to body.
						body.append( "<link rel='stylesheet' class='stlst-font-test-" + window.stlst_legacy.get_basic_id( jQuery.trim( data.replace( / /g, '+' ) ) ) + "'  href='https://fonts.googleapis.com/css?family=" + jQuery.trim( data.replace( / /g, '+' ) ) + ":300italic,300,400,400italic,500,500italic,600,600italic,700,700italic' type='text/css' media='all' />" );

					}

				}

			} */

			// If have data, so set!
			/* if ( id == 'font-family' && data.indexOf( "," ) == -1 ) {

				// Getting value
				let value = jQuery( "#stlst-font-family-data option" ).filter( function() {
					return jQuery( this ).text() === data;
				}).first().attr( "value" );

				// Select by value.
				if (value !== undefined ) {

					value = value.toLowerCase().replace( /\b[a-z]/g, function(letter) {
						return letter.toUpperCase();
					} )

					theOption.val(value);
					return value;
				} else {

					data = data.toLowerCase().replace( /\b[a-z]/g, function(letter) {
						return letter.toUpperCase();
					} )

					theOption.val( data );
					return data;
				}

			} else {
				// set value.
				theOption.val( data );
				return data;

			} */

			/* if ( id == 'font-family' ) {
				jQuery( "#stlst-font-family,#stlst-font-weight" ).each( function() {
					jQuery( this ).css( "fontFamily", data );
				} )
			} */
		}
	// IF THIS IS A SELECT TAG
	// ============================================================
	} else if ( 'select' === control ) {
		// Active none button.
		// idPrt.find( ".stlst-btn-action.active" ).trigger( "click" );

		// If data is none, auto etc, so active none button.
		/* if ( data == idPrt.find( ".stlst-none-btn" ).text() ) {
			idPrt.find( ".stlst-none-btn" ).trigger( "click" );
		} */

		return data;
		// If not have this data in select options, insert this data.
		/* if ( theOption.val() === null && data != idPrt.find( ".stlst-none-btn" ).text() && data !== undefined ) {
			theOption.val( data );
			return data;
		}

		return false; */

	// IF THIS IS A RADIO TAG
	// ============================================================
	} else if ( 'radio' === control ) {
		// Fix background size rule.
		if ( id == 'background-size' ) {
			if ( data == 'auto' || data == '' || data == ' ' || data == 'auto auto' ) {
				data = 'auto auto';
			}
		}

		return data;

	// IF THIS IS COLORPICKER
	// ============================================================
	} else if ( 'color' === control ) {
		// Convert to rgb and set value.
		let rgbd;
		if ( window.stlst_legacy.isDefined( data ) ) {
			if ( data.indexOf( "#" ) == -1 ) {
				rgbd = window.stlst_legacy.get_color( data );
			}
		}

		// browsers return value always in rgb format.
		return data;

	// IF THIS IS INPUT OR TEXTAREA
	// ============================================================
	} else if ( 'background-image' === id ) {
		// clean URL() prefix for background image. no gradients
		if ( 'disable' !== data && false !== data && undefined !== data && -1 === data.indexOf( "linear-gradient( " ) ) {
			return data.replace( /"/g, "" ).replace( /'/g, "" ).replace( /url\(/g, "" ).replace( /\)/g, "" );
		} // Else.
		return false;
	}
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-default-value.js